export default function HoldIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2799 8.49999L11.9499 9.11999V7.11998L11.9399 7.16004L14.2699 7.78004L14.7899 5.85004L13.0199 5.38004L13.4799 3.61004L11.5499 3.09004L10.9299 5.42004L10.9399 5.37998L8.98994 4.11998L10.6999 2.41L9.27994 1L7.98994 2.29L6.69994 1L5.27994 2.41L6.98994 4.12L4.98994 5.38004L4.40994 3.05004L2.48994 3.57004L2.95994 5.34004L1.18994 5.81004L1.70994 7.74004L4.03994 7.12004L4.03994 9.13005L1.70994 8.51005L1.18994 10.4401L2.95994 10.9101L2.48994 12.6701L4.41994 13.1901L5.03994 10.86L6.98994 12.12L5.27994 13.83L6.69994 15.24L7.98994 13.95L9.27994 15.24L10.6899 13.83L8.98994 12.12L9.98994 11.575L10.9899 10.85L11.6099 13.18L13.4899 12.67L13.0199 10.9L14.7899 10.43L14.2799 8.49999ZM5.98994 7.12004L7.98994 5.84998L9.98994 7.11998V9.11999L7.98994 10.39L5.98994 9.12005V7.12004Z"
        fill="#191A19"
        fillOpacity="0.4"
      />
    </svg>
  );
}
